import { TIME_CONSTANTS_IN_SECONDS } from '@/shared/constants/time';
import { getCookie, setCookie } from 'cookies-next';
import { v4 as uuidv4 } from 'uuid';

const VISITOR_ID_COOKIE = 'wt_visitor_id';

export const getOrCreateVisitorId = async (): Promise<string> => {
  const existingVisitorId = await getCookie(VISITOR_ID_COOKIE);

  if (existingVisitorId) {
    return existingVisitorId;
  }

  const newVisitorId = uuidv4();
  setCookie(VISITOR_ID_COOKIE, newVisitorId, {
    maxAge: TIME_CONSTANTS_IN_SECONDS.ONE_YEAR,
    path: '/',
    sameSite: 'lax',
    secure: process.env.NODE_ENV === 'production',
  });

  return newVisitorId;
};
